import request from '@/utils/request'

//基础path
const basePath = "/api/enterprise/job";

export const batchUploadPath = `${basePath}/batch/import`;

// 分页查询职位
export function getPage(params) {
    return request({
        url: `${basePath}/list`,
        method: 'get',
        params: params
    })
}

// 管理员分页查询职位
export function getPageToManager(params) {
    return request({
        url: `/api/enterprise/job/list/manager`,
        method: 'get',
        params: params
    });
}

/**
 * 查询更多职位列表
 * @param pageNumber
 * @param pageSize
 * @param positionName
 */
export function getMoreJobList(params) {
    return request({
        url: `/api/enterprise/job/public/moreJobList`,
        method: 'get',
        params: params
    });
}

/**
 * 根据条件搜索条件列表
 * @param params
 */
export function getPublicJob(positionName, pageNumber, pageSize) {
    return request({
        url: `/api/enterprise/job/public/list?positionName=${positionName}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        methosd: 'get'
    });
}

// 查看职位详情
export function queryData(params) {
    return request({
        url: '/api/enterprise/job/public',
        method: 'get',
        params: params
    })
}


// 添加职位
export function handleAdd(params) {
    return request({
        url: '/api/enterprise/job',
        method: 'post',
        data: params
    })
}

// 添加职位
export function handleAddByEnterpriseId(enterpriseId, params) {
    return request({
        url: `/api/enterprise/job/${enterpriseId}`,
        method: 'post',
        data: params
    })
}

// 根据名称查询职位子集列表
export function handleUpdate(params) {
    return request({
        url: '/api/enterprise/job',
        method: 'put',
        data: params
    })
}

// 更新发布时间
export function handleUpdateTime(id) {
    return request({
        url: '/api/enterprise/job/updateDate/' + id,
        method: 'put',
    })
}

// 更新状态
export function handleUpdateStatus(id, status) {
    return request({
        url: '/api/enterprise/job/updateStatus/' + id + "/" + status,
        method: 'put',
    })
}

// 复制职位
export function copyJob(id, newName) {
    return request({
        url: '/api/enterprise/job/copyJob/' + id + "/" + newName,
        method: 'put',
    })
}

// 判断当前用户是否已经申请了该职位
export function checkUserIdIsInJobPositionApplyRecord(jobId) {
    return request({
        url: '/api/enterprise/jobPositionApplyRecord/checkUserIsInRecord/' + jobId,
        method: 'get',
    })
}

/**
 * 发送者信息
 */
export function queryPublisherInfo(id) {
    return request({
        url: `/api/enterprise/job/publisher/${id}`,
        method: 'get'
    })
}

/**
 * 根据职位ID集合批量删除
 */
export function batchDelete(params) {
    return request({
        url: `${basePath}/batch/delete`,
        method: 'delete',
        params: params
    })
}

/**
 * 获取当前用户企业职位列表
 */
export function findEnterprisePositionList() {
    return request({
        url: `${basePath}/enterprise/list`,
        method: 'get'
    })
}

/**
 * 获取热门职位前10
 */
export function findHotEnterprisePositionTop() {
    return request({
        url: `${basePath}/public/hot`,
        method: 'get'
    })
}

/**
 * 获取推荐职位
 */
export function findRecommendJob() {
    return request({
        url: `/api/enterprise/job/recommend`,
        method: 'get'
    })
}

/**
 * 获取ES职位分页
 */
export function findPublicEnterprisePagesByEs(params) {
    return request({
        url: `${basePath}/public/es`,
        method: 'get',
        params: params
    })
}

/**
 * 获取ES职位分页
 */
export function findJobPagesByEnterpriseId(enterpriseId, params) {
    return request({
        url: `${basePath}/public/page/${enterpriseId}`,
        method: 'get',
        params: params
    })
}

/**
 * 获取所有公开职位中城市中市出现的前十列表
 */
export function getPublicJobCityTop() {
    return request({
        url: `${basePath}/public/city`,
        method: 'get'
    })
}


